module.exports = __webpack_public_path__ + "static/media/construction-worker.5f143b4a.svg";